import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import registerComponents from './components.js'

// Font-Awesome (free solid set, bundled locally — no CDN).
import FontAwesomeIcon from 'helpers/fontawesome'

// Self-hosted Inter — no external Google Fonts request.
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'

import './assets/sass/style.scss'

Vue.config.productionTip = false
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Auto-register all components under src/components (NavBar, MenuLeft, templates…).
registerComponents(Vue)

// Rehydrate/verify the session before mounting so guarded routes resolve.
store.dispatch('auth/restore').finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
})
